module.exports = __webpack_public_path__ + "static/img_1824-e10fe7a2940349dc6cf959cd0313e588.webp";